import { useState, useEffect, useCallback } from "react";
import {
  fetchCampaignTypes,
  createCampaignType,
  updateCampaignType,
} from "../Services/APIService";
import { CampaignType, CampaignTypeFormData } from "../types/campaignType.types";

export const useCampaignTypeTable = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [searchText, setSearchText] = useState("");
  const [campaignTypes, setCampaignTypes] = useState<CampaignType[]>([]);
  const [filteredCampaignTypes, setFilteredCampaignTypes] = useState<CampaignType[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editCampaignTypeId, setEditCampaignTypeId] = useState<number | null>(null); // Changed from editCampaignTypeData
  const [selectedRows, setSelectedRows] = useState<CampaignType[]>([]);
  const [toggleCleared, setToggleCleared] = useState(false);

  const fetchCampaignTypeData = useCallback(async () => {
    setLoading(true);
    try {
      const tenantId = Number(localStorage.getItem("tenantId")) || 1000;
      const token = localStorage.getItem("authToken") || "";
      const response = await fetchCampaignTypes();
      setCampaignTypes(response?.campaignTypes || []);
    } catch (err: any) {
      setError(err.message || "Failed to fetch campaign types");
      console.error(err);
    } finally {
      setLoading(false);
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCampaignTypeData();
  }, [fetchCampaignTypeData]);

  useEffect(() => {
    setFilteredCampaignTypes(
      campaignTypes.filter((type) =>
        type.name.toLowerCase().includes(searchText.toLowerCase())
      )
    );
  }, [searchText, campaignTypes]);

  const handleRowSelected = (state: { selectedRows: CampaignType[] }) => {
    setSelectedRows(state.selectedRows);
  };

  const handleEdit = (campaignType: CampaignType) => {
    setEditCampaignTypeId(campaignType.id); // Set ID instead of data
    setIsEditModalOpen(true);
  };

  const toggleSidebar = () => setIsSidebarCollapsed(!isSidebarCollapsed);

  return {
    isSidebarCollapsed,
    toggleSidebar,
    isLoading,
    loading,
    error,
    searchText,
    setSearchText,
    filteredCampaignTypes,
    fetchCampaignTypeData,
    isModalOpen,
    setIsModalOpen,
    isEditModalOpen,
    setIsEditModalOpen,
    editCampaignTypeId,
    setEditCampaignTypeId,
    selectedRows,
    toggleCleared,
    handleRowSelected,
    handleEdit,
  };
};